import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateStudentForm from "../../forms/CreateOrUpdateStudentForm";
import { StudentResponseDto } from "../../shared/dtos/student/StudentResponseDto";

interface UpdateStudentModalProps {
  open: boolean;
  onClose: () => void;
  student: StudentResponseDto | null;
  loading: boolean;
  error: string | null;
}

const UpdateStudentModal: React.FC<UpdateStudentModalProps> = ({
  open,
  onClose,
  student,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Student: ${student?.firstName || ""}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateStudentForm
      isEditing={true}
      student={student}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateStudentModal;
